var _path, _mask, _g, _mask2, _g2, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 700,
    viewBox: "0 0 540 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H540V700H0.5L52 0Z",
    fill: "#D8EBF0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: -265,
    width: 688,
    height: 688
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M805 79C805 268.986 650.986 423 461 423C271.014 423 117 268.986 117 79C117 -110.986 271.014 -265 461 -265C650.986 -265 805 -110.986 805 79Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 0H540V423H74V0Z",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 400,
    width: 499,
    height: 499
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 256.5,
    cy: 649.5,
    r: 249.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 375,
    width: 517,
    height: 325,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.14 111.128V171.582C275.14 176.723 270.876 180.93 265.664 180.93H115.932C118.775 196.823 97.452 202.432 97.452 202.432C111.667 188.409 97.452 180.93 97.452 180.93H10.2663C5.05407 180.93 0.789551 176.723 0.789551 171.582V111.128C0.789551 105.986 5.05407 101.779 10.2663 101.779H265.664C270.876 101.779 275.14 105.986 275.14 111.128Z",
    fill: "white",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.865 125.689H94.8057C94.1252 125.689 93.5364 125.122 93.5364 124.095V121.653C93.5364 120.626 94.1252 120.06 94.8057 120.06H174.865C175.546 120.06 176.135 120.626 176.135 121.653V124.095C176.135 125.094 175.423 125.689 174.865 125.689Z",
    fill: "url(#paint1_linear)",
    stroke: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.237 141.13V141.158L246.24 141.187C246.344 142.091 245.501 142.923 244.372 142.923H95.401C94.3325 142.923 93.5364 142.129 93.5364 141.13V140.413C93.5364 139.414 94.3325 138.62 95.401 138.62H244.372C245.441 138.62 246.237 139.414 246.237 140.413V141.13Z",
    fill: "url(#paint3_linear)",
    stroke: "url(#paint4_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.237 159.69V159.718L246.24 159.747C246.344 160.651 245.501 161.483 244.372 161.483H95.401C94.3325 161.483 93.5364 160.689 93.5364 159.69V158.973C93.5364 157.974 94.3325 157.18 95.401 157.18H244.372C245.441 157.18 246.237 157.974 246.237 158.973V159.69Z",
    fill: "url(#paint5_linear)",
    stroke: "url(#paint6_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.24,
    y: 113.516,
    width: 54.3256,
    height: 53.5909,
    fill: "url(#pattern0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8596 240.294V300.748C53.8596 305.889 58.1241 310.096 63.3363 310.096H213.068C210.225 325.989 231.548 331.598 231.548 331.598C217.333 317.575 231.548 310.096 231.548 310.096H318.734C323.946 310.096 328.211 305.889 328.211 300.748V240.294C328.211 235.152 323.946 230.945 318.734 230.945H63.3363C58.1241 230.945 53.8596 234.996 53.8596 240.294Z",
    fill: "white",
    stroke: "url(#paint7_linear)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.451 265.388H147.391C146.359 265.388 145.622 264.516 145.622 263.295V260.853C145.622 259.632 146.359 258.76 147.391 258.76H227.451C228.483 258.76 229.22 259.632 229.22 260.853V263.295C229.22 264.516 228.336 265.388 227.451 265.388Z",
    fill: "url(#paint8_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297.104 282.623H147.987C146.657 282.623 145.622 281.62 145.622 280.33V279.613C145.622 278.323 146.657 277.32 147.987 277.32H296.956C298.287 277.32 299.321 278.323 299.321 279.613V280.33C299.469 281.62 298.434 282.623 297.104 282.623Z",
    fill: "url(#paint9_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5633 292.62C106.735 292.62 117.413 282.164 117.413 269.266C117.413 256.368 106.735 245.913 93.5633 245.913C80.3916 245.913 69.7139 256.368 69.7139 269.266C69.7139 282.164 80.3916 292.62 93.5633 292.62Z",
    fill: "url(#paint10_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5837 166.869C55.7686 166.869 67.2677 155.341 67.2677 141.12C67.2677 126.9 55.7686 115.371 41.5837 115.371C27.3988 115.371 15.8997 126.9 15.8997 141.12C15.8997 155.341 27.3988 166.869 41.5837 166.869Z",
    fill: "#F3D11F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M461.539 626.245H277.258C273.568 626.245 270.615 623.309 270.615 619.638V472.218C270.615 468.548 273.568 465.612 277.258 465.612H461.539C465.23 465.612 468.182 468.548 468.182 472.218V619.516C468.182 623.309 465.23 626.245 461.539 626.245Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.258 466.223C273.907 466.223 271.23 468.886 271.23 472.218V619.638C271.23 622.971 273.907 625.633 277.258 625.633H461.539C464.883 625.633 467.567 622.978 467.567 619.516V472.218C467.567 468.886 464.89 466.223 461.539 466.223H277.258ZM270 472.218C270 468.21 273.228 465 277.258 465H461.539C465.569 465 468.797 468.21 468.797 472.218V619.516C468.797 623.639 465.577 626.856 461.539 626.856H277.258C273.228 626.856 270 623.646 270 619.638V472.218Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M451.205 497.053H287.099C283.778 497.053 281.072 494.362 281.072 491.181C281.072 487.878 283.778 485.186 287.099 485.186H451.205C454.527 485.186 457.233 487.878 457.233 491.181C457.233 494.362 454.527 497.053 451.205 497.053ZM287.099 487.633C285.131 487.633 283.532 489.223 283.532 491.181C283.532 493.138 285.131 494.729 287.099 494.729H451.205C453.174 494.729 454.773 493.138 454.773 491.181C454.773 489.223 453.174 487.633 451.205 487.633H287.099Z",
    fill: "url(#paint12_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 85.0055,
    height: 45.633,
    transform: "translate(281.072 510.144)",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.466 555.777H289.683C284.885 555.777 281.072 551.984 281.072 547.213V518.707C281.072 513.936 284.885 510.144 289.683 510.144H357.466C362.263 510.144 366.077 513.936 366.077 518.707V547.213C366.077 551.984 362.14 555.777 357.466 555.777ZM289.683 512.59C286.238 512.59 283.532 515.282 283.532 518.707V547.213C283.532 550.638 286.238 553.33 289.683 553.33H357.466C360.91 553.33 363.617 550.638 363.617 547.213V518.707C363.617 515.282 360.91 512.59 357.466 512.59H289.683Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.622 555.777H380.839C376.042 555.777 372.228 551.984 372.228 547.213V518.707C372.228 513.936 376.042 510.144 380.839 510.144H448.622C453.42 510.144 457.233 513.936 457.233 518.707V547.213C457.233 551.984 453.42 555.777 448.622 555.777ZM380.839 512.59C377.395 512.59 374.688 515.282 374.688 518.707V547.213C374.688 550.638 377.395 553.33 380.839 553.33H448.622C452.067 553.33 454.773 550.638 454.773 547.213V518.707C454.773 515.282 452.067 512.59 448.622 512.59H380.839Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357.466 608.016H289.683C284.885 608.016 281.072 604.223 281.072 599.452V570.947C281.072 566.175 284.885 562.383 289.683 562.383H357.466C362.263 562.383 366.077 566.175 366.077 570.947V599.452C366.077 604.101 362.14 608.016 357.466 608.016ZM289.683 564.83C286.238 564.83 283.532 567.521 283.532 570.947V599.452C283.532 602.878 286.238 605.569 289.683 605.569H357.466C360.91 605.569 363.617 602.878 363.617 599.452V570.947C363.617 567.521 360.91 564.83 357.466 564.83H289.683Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M448.622 608.016H380.839C376.042 608.016 372.228 604.223 372.228 599.452V570.947C372.228 566.175 376.042 562.383 380.839 562.383H448.622C453.42 562.383 457.233 566.175 457.233 570.947V599.452C457.233 604.101 453.42 608.016 448.622 608.016ZM380.839 564.83C377.395 564.83 374.688 567.521 374.688 570.947V599.452C374.688 602.878 377.395 605.569 380.839 605.569H448.622C452.067 605.569 454.773 602.878 454.773 599.452V570.947C454.773 567.521 452.067 564.83 448.622 564.83H380.839Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M307.274 546.846C314.952 546.846 321.175 540.656 321.175 533.021C321.175 525.386 314.952 519.197 307.274 519.197C299.597 519.197 293.373 525.386 293.373 533.021C293.373 540.656 299.597 546.846 307.274 546.846Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M307.274 600.308C314.952 600.308 321.175 594.119 321.175 586.484C321.175 578.849 314.952 572.66 307.274 572.66C299.597 572.66 293.373 578.849 293.373 586.484C293.373 594.119 299.597 600.308 307.274 600.308Z",
    fill: "#F3D11F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M397.57 598.963C405.247 598.963 411.471 592.773 411.471 585.138C411.471 577.503 405.247 571.314 397.57 571.314C389.892 571.314 383.669 577.503 383.669 585.138C383.669 592.773 389.892 598.963 397.57 598.963Z",
    fill: "url(#paint18_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M462.769 649C480.502 649 494.877 634.704 494.877 617.069C494.877 599.434 480.502 585.138 462.769 585.138C445.037 585.138 430.662 599.434 430.662 617.069C430.662 634.704 445.037 649 462.769 649Z",
    fill: "#F3D11F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M397.57 546.112C405.247 546.112 411.471 539.922 411.471 532.287C411.471 524.652 405.247 518.463 397.57 518.463C389.892 518.463 383.669 524.652 383.669 532.287C383.669 539.922 389.892 546.112 397.57 546.112Z",
    fill: "#F3D11F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M351.684 526.048H329.049C328.31 526.048 327.818 525.559 327.818 524.824C327.818 524.09 328.31 523.601 329.049 523.601H351.684C352.422 523.601 352.914 524.09 352.914 524.824C352.914 525.559 352.299 526.048 351.684 526.048Z",
    fill: "url(#paint19_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M351.684 534.245H329.049C328.31 534.245 327.818 533.755 327.818 533.021C327.818 532.287 328.31 531.798 329.049 531.798H351.684C352.422 531.798 352.914 532.287 352.914 533.021C352.914 533.755 352.299 534.245 351.684 534.245Z",
    fill: "url(#paint20_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M445.424 526.048H422.789C422.05 526.048 421.558 525.559 421.558 524.824C421.558 524.09 422.05 523.601 422.789 523.601H445.424C446.162 523.601 446.654 524.09 446.654 524.824C446.654 525.559 446.162 526.048 445.424 526.048Z",
    fill: "url(#paint21_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M476.178 630.282C475.932 630.282 475.686 630.16 475.44 630.037L460.186 619.271V595.782C460.186 595.048 460.678 594.558 461.416 594.558C462.154 594.558 462.646 595.048 462.646 595.782V618.048L476.916 628.08C477.532 628.447 477.655 629.181 477.163 629.793C476.916 630.037 476.547 630.282 476.178 630.282Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -4.07483,
    y1: 202.432,
    x2: 348.593,
    y2: 202.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 91.5541,
    y1: 126.189,
    x2: 199.017,
    y2: 126.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 91.5541,
    y1: 126.189,
    x2: 199.017,
    y2: 126.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 90.311,
    y1: 143.423,
    x2: 287.903,
    y2: 143.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 90.311,
    y1: 143.423,
    x2: 287.903,
    y2: 143.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 90.311,
    y1: 161.983,
    x2: 287.903,
    y2: 161.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 90.311,
    y1: 161.983,
    x2: 287.903,
    y2: 161.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 48.9952,
    y1: 331.598,
    x2: 401.663,
    y2: 331.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 144.14,
    y1: 265.388,
    x2: 251.602,
    y2: 265.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 142.897,
    y1: 282.623,
    x2: 340.489,
    y2: 282.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 68.8681,
    y1: 292.62,
    x2: 130.183,
    y2: 292.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 266.475,
    y1: 626.856,
    x2: 522.021,
    y2: 626.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 277.948,
    y1: 497.053,
    x2: 504.397,
    y2: 497.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 279.564,
    y1: 555.777,
    x2: 388.836,
    y2: 555.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 370.721,
    y1: 555.777,
    x2: 479.992,
    y2: 555.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 279.564,
    y1: 608.016,
    x2: 388.836,
    y2: 608.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 370.721,
    y1: 608.016,
    x2: 479.992,
    y2: 608.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 292.88,
    y1: 546.846,
    x2: 328.619,
    y2: 546.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 383.176,
    y1: 598.963,
    x2: 418.914,
    y2: 598.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 327.373,
    y1: 526.048,
    x2: 359.633,
    y2: 526.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 327.373,
    y1: 534.245,
    x2: 359.633,
    y2: 534.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 421.113,
    y1: 526.048,
    x2: 453.373,
    y2: 526.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184401,
    stopColor: "#007A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948532,
    stopColor: "#70D0C6"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVwAAAFSCAYAAAC+HGdcAAAACXBIWXMAAGriAABq4gG3J2AeAAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.1b4e27f0ad4dc874b80cd238d13deaa9.svg";
export { ForwardRef as ReactComponent };